import jMoment from 'moment-jalaali'
import Matrix from './scripts/Matrix'
import history from './history'
import axios from 'axios'
import Cookies from 'universal-cookie'
import TagManager from './googleTagManager'

jMoment.loadPersian({ dialect: 'persian-modern' })

// const baseUrl = 'http://192.168.101.74:8585' // amir
// const baseUrl = 'http://localhost:8585' // hossein
const baseUrl = 'https://www.tebinja.com'
// const baseUrl = 'http://1633-5-112-91-225.ngrok.io'
// const baseUrl = 'http://localhost:8282' // hossein
const pwaUrl = 'https://pwad.tebinja.com'
const cdnUrl = 'https://cdn.tebinja.com/main'
const siteURL = window.location.protocol + '//' + window.location.hostname

const urls = {
  pwaUrl,
  baseUrl,
  cdnUrl,
  PATIENT_CONSULT_REQUEST_URL: baseUrl + "/api/v1/consultrequest/questions/patient",
  sendNumberURL: baseUrl + "/api/v1/users",
  signupURL: baseUrl + "/api/v1/patients",
  consultRequests: baseUrl + '/api/v1/consultrequest/questions/available',
  consultRequsetWaitingForPayment: id => baseUrl + `/api/v1/consultrequest/${id}`,
  consultAskQuestion: baseUrl + '/api/v1/consultrequest/ask',
  consultNewAskQuestion: baseUrl + '/api/v1/consultrequest/newask',
  askQuestionCallbackURL: siteURL + '/chats',
  consultAskQuestionWithQuiz: baseUrl + '/api/v1/consultrequest/askwithquiz',
  initAsk: baseUrl + '/api/v1/consultrequest/initAsk',
  finalizeAsk: baseUrl + '/api/v1/consultrequest/finalizeAsk',
  consultCategories: baseUrl + '/api/v1/consultrequest/consultCategories',
  consultCategoryURL: (id) => (baseUrl + `/api/v1/consultrequest/consultCategory/${id}`),
  assignConsultRequestURL: baseUrl + '/api/v1/consultrequest/assign',
  calcCoronaURL: baseUrl + '/api/v1/consultrequest/calcCoronaQuiz',
  quizURL: baseUrl + '/api/v1/consultrequest/quiz',
  roomStatusURL: baseUrl + '/api/v1/matrix/rooms/status',
  roomRateURL: baseUrl + '/api/v1/matrix/rooms/rates',
  consultHistory: baseUrl + '/api/v1/consultrequest/consult/followup',
  lockRoomUrl: baseUrl + '/api/v1/consultrequest/close',
  myWalletUrl: baseUrl + '/api/v1/wallet/mywallet',
  chargeWallet: baseUrl + '/api/v1/wallet/charge',
  sendDoctorInfoUrl: baseUrl + '/api/v1/users/contact',
  useCoupon: baseUrl + '/api/v1/discounts/use',
  deleteCoupon: baseUrl + '/api/v1/discounts',
  doctorUrl: id => baseUrl + `/api/v1/consultrequest/doctorprofile/${id}`,
  doctorsUrl: (categoryId, page = 0) => baseUrl + `/api/v1/consultrequest/doctorprofile/category/${categoryId}?page=${page}`,
  callRequest: baseUrl + '/api/v1/call-request/',
  getAllConsultRequest: baseUrl + '/api/v1/consultrequest/roomstatus',
  voiceConsultList: baseUrl + '/api/v1/consultrequest/type/voice',
  image: cdnUrl+'/img/uploads/doctors/thumbnails/',
  makeVoiceCall: baseUrl + '/api/v1/call-request/call',
  getComments: id => baseUrl + `/api/v1/consultrequest/doctor/${id}/comments`,
  notifyDoctor: baseUrl + '/api/v1/consultrequest/notification',
  captcha: baseUrl + '/api/v1/captcha',
  myUserInfoUrl: baseUrl + '/api/v1/patients',
  isFirstConsult: baseUrl + '/api/v1/discounts/first-consultant',
  searchDoctor: baseUrl + '/api/v1/consultrequest/doctors/search',
  notifyVideoCall: baseUrl + '/api/v1/call-request/video-call',
  notifyMessage: baseUrl + '/api/v1/consultrequest/notify'
}
const getJalaiData = (startDate) => {
  let m;
  m = jMoment(startDate)
  return (m.jYear() + '/' + (m.jMonth() + 1) + '/' + m.jDate())
}

const doctorImageUrl = (docImage) => {
  return cdnUrl + '/img/uploads/doctors/thumbnails/' + docImage
}

const iaxios = async (config, hasAuth) => {
  if (hasAuth) {
    config.headers = { ...(config.headers || {}), 'x-access-token': Matrix.getToken() }
  }
  return await axios(config).catch((e) => {
    console.log(e.response)
    if (e.response && e.response.data && e.response.data.message_id === 110) {
      e.response.data.message = 'مجددا ورود کنید'
      Matrix.logout()
      history.push('/login')
    } else
      throw e
  });
}

const timeStampToHHMM = (ts) => {
  return jMoment(ts).format('HH:mm');
}
const timeStampToDDMM = (ts) => {
  return jMoment(ts).format('jD jMMMM');
}

const goBack = () => {
  window.history.back();
}
const roomMemberDisplayName = (roomMember) => {
  if (!roomMember) return ''
  if (roomMember.userId === '@matrixdoctor/tebinja.com:' + Matrix.matrixBaseDomain)
    return 'دکتر عمومی طبینجا'
  const nameToken = roomMember.name.split('_')
  if (nameToken.length > 1) return nameToken[1]
  return nameToken[0].replace('matrix', '')
  // return roomMember.name

}

const mainMember = (joinedMember, userId) => {
  let mainMember
  for (let i = 0; i < joinedMember.length; i++) {
    const member = joinedMember[i];
    // console.log(member)
    if (member.userId !== userId && member.userId !== '@matrixadmin/tebinja.com:' + Matrix.matrixBaseDomain)
      mainMember = member
  }
  return mainMember
}

const initRoomNameAndMember = (room, userId) => {
  // console.log(this.state.room.getJoinedMembers())
  const joinedMember = room.getJoinedMembers()
  if (joinedMember && Array.isArray(joinedMember)) {
    // console.log(joinedMember, '===============================')
    if (joinedMember.length > 3)
      return { isGroup: true, mainMember: null, title: room.name }
    const mainmember = mainMember(joinedMember, userId)
    // console.log(mainmember)
    return { isGroup: false, mainMember: mainmember, title: roomMemberDisplayName(mainmember) }
  }
  return { isGroup: true, mainMember: null, title: room.name }
}

const createTextLink = (text) => {
  return (text || "").replace(
    /((http|https|ftp|ftps)\:\/\/)?[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/\S*)?/gim,
    function (match) {
      let url = match
      if (!match.match('^https?:\/\/')) {
        url = 'http://' + match;
      }
      return '<a href="' + url + '" target="blank">' + match + '</a>';
    }
  );
}


const getMainRole = (roles) => {
  let mainRole = roles.includes("doctor")
    ? "doctor"
    : roles.includes("secretary")
      ? "secretary"
      : roles.includes("patient")
        ? "patient"
        : roles.includes("admin")
          ? "admin"
          : null;
  return mainRole
}

const faTOen = (s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
const arTOen = (s => s.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)))

const formatMoney = (price) => {
  return (parseInt(price)).toLocaleString("fa-IR", { minimumFractionDigits: 0 })
}

const getCookies = () => new Cookies()

const sendGtmEvent = (eventCategory, eventLabel) => {
  console.log('tag manager', 'fired sendEventTagManager', eventCategory, eventLabel)

  TagManager.dataLayer({
    dataLayer: {
      event: 'events',
      eventCategory,
      eventAction: 'PWA',
      eventLabel
    }
  })
}

export default {
  getJalaiData,
  timeStampToHHMM,
  goBack,
  urls,
  getMainRole,
  doctorImageUrl,
  roomMemberDisplayName,
  initRoomNameAndMember,
  mainMember,
  createTextLink,
  timeStampToDDMM,
  iaxios,
  faTOen,
  arTOen,
  formatMoney,
  getCookies,
  sendGtmEvent
}
